import { fabric } from 'fabric';
import { generateSvgForOTP } from './personalization/generateSvgForOTP';
import {
    newModalFromString
} from './components/modal';
import sizePanel from './product/sizePanel';
import SELECTORS from './personalization/selectors';
import CLASSES from './personalization/classes';

let customizePosition, customizeSide, customizeText, customizeFont, customizePattern, customizeColor, allowedCharactersRegex, canvas, canvasText, canvasRect, canvasGroup, canvasImage, top, left, topBack, leftBack, badWords, loadingTime, isStepTwo, rectColor, switchDisable, badWordsLink;

function initText () {
    const { textInput, fontsButtons, colorsButtons } = SELECTORS;
    $(textInput).val('');
    $(fontsButtons).removeClass('active');
    setActiveMiddle(fontsButtons);
    $(colorsButtons).removeClass('active');
    $(colorsButtons).first().addClass('active');

    customizePosition = '0';
    customizeText = '';
    customizeFont = '"Didot",Times,serif';
    customizePattern = '1';
    customizeColor = '#000000';
    allowedCharactersRegex = $(textInput).data('regex-pattern');
}

const setActiveMiddle = (selector) => {
    const $elements = $(selector);
    const middleIndex = Math.floor($elements.length / 2);

    $elements.removeClass('active').eq(middleIndex).addClass('active');
};

function initVariables () {
    customizeSide = '0';
    top = parseInt($(SELECTORS.pixelText).attr('top-desktop'));
    left = parseInt($(SELECTORS.pixelText).attr('left-desktop'));
    topBack = parseInt($(SELECTORS.pixelText).attr('top-desktop-back'));
    leftBack = parseInt($(SELECTORS.pixelText).attr('left-desktop-back'));
    switchDisable = $(SELECTORS.pixelText).attr('switch-disable') === 'true';
    badWords = [];
    badWordsLink = $('#badWords').attr('badWords');
    loadingTime = 300;
    isStepTwo = false;
    rectColor = '#3C3738';

    initText();
}

/**
 * @function initCanvas - Init the canvas
 * @returns {void}
 */
function initCanvas (imageToLoad = SELECTORS.imgFront) {
    canvas = new fabric.StaticCanvas('personalization-canvas', {
        width: 2000,
        height: 3000,
        enableRetinaScaling: false
    });

    let transformX = left / canvas.width * 100;
    let transformY = top / canvas.height * 100;
    let translateY = transformY < 25 ? 0 : transformY > 75 ? -50 : 25 - transformY;

    $(SELECTORS.personalizationCanvas).css({
        transformOrigin: transformX + '% ' + transformY + '%',
        transform: 'scale(1)',
        top: isStepTwo ? translateY + '%' : '0'
    });

    $(SELECTORS.zoomButton).removeClass('active');

    const canvasRatio = 7.125; // canvas ratio calculated based on the design dimensions of the image (2000/355)
    canvasText = new fabric.Textbox(customizeText, {
        top: top,
        left: left,
        originX: 'center',
        originY: 'center',
        width: canvasRatio * 48,
        fontSize: canvasRatio * 10,
        lineHeight: canvasRatio * 15,
        fontFamily: customizeFont,
        textAlign: 'center',
        fill: customizeColor,
    });

    if (isStepTwo) {
        canvasRect = new fabric.Rect({
            strokeDashArray: [canvasRatio * 5, canvasRatio * 5],
            top: top,
            left: left,
            originX: 'center',
            originY: 'center',
            width: canvasRatio * 48,
            height: canvasRatio * 26,
            fill: '',
            stroke: rectColor,
            strokeWidth: canvasRatio * 1
        });
    }

    let imageUrl = $(imageToLoad).attr('src');
    fabric.Image.fromURL(imageUrl, function (img) {
        canvasImage = img.set({
            top: 0,
            selectable: false,
            hasRotatingPoint: true,
            width: canvas.width,
            height: canvas.height
        });
        canvasImage.scaleToWidth(canvas.width);

        if (isStepTwo) {
            canvasGroup = new fabric.Group([canvasImage, canvasText, canvasRect], {});
        } else {
            canvasGroup = new fabric.Group([canvasImage, canvasText], {});
        }
        canvas.add(canvasGroup);

        setTimeout(() => {
            canvas.renderAll();
        }, loadingTime);
    });
}

/**
 * @function initForm - Saves customization values inside the submit form inputs
 */
function initForm () {
    $('.form-position').val(customizePosition);
    $('.form-text').val(customizeText);
    $('.form-font').val(customizeFont);
    $('.form-pattern').val(customizePattern);
    $('.form-color').val(customizeColor);
    $('.form-color-selected-circle-src').val($('#imageColor').attr('src'));
}

/**
 * @function updateCanvasElem - Update the canvas element based on a property and value
 * @param {Object} elem - Canvas element
 * @param {String} property - Property to update
 * @param {*} value - Value to set
 */
function updateCanvasElem (elem, property, value) {
    if (elem) {
        elem.set(property, value);

        setTimeout(() => {
            canvas.renderAll();
        }, loadingTime);
    }
};

/**
 * @function waitToLoadAllImages - Wait for all images to load
 * @returns {Promise} - Promise that resolves when all images are loaded
 */
function waitToLoadAllImages () {
    let defer = jQuery.Deferred();
    let imagesNumber = $('.js-personalization-image').length;
    let loadComplete = 0;
    $('.js-personalization-image').one('load', function () {
        loadComplete++;
        if (loadComplete === imagesNumber) {
            defer.resolve(true);
        }
    }).on('error', function () {
        loadComplete++;
        if (loadComplete === imagesNumber) {
            defer.resolve(true);
        }
    }).each(function () {
        if (this.complete) {
            $(this).trigger('load');
        } else if (this.error) {
            $(this).error();
        }
    });
    return defer.promise();
};

/**
 * @function runPersonalizationListener - Init the canvas, add event listeners on the modal elements and init the form
 */
function runPersonalizationListener () {
    initVariables();

    $.ajax({
        url: badWordsLink,
        method: 'POST',
        success: data => {
            badWords = data.context.wordsArr;
        },
        error: () => {
            console.error('Error in AJAX request');
        }
    });

    $('#size').attr('size-attribute', $('[data-attr="size"] input:checked').attr('id'));

    waitToLoadAllImages().then(function () {
        initCanvas();
        positionChoice();
    });

    initForm();

    $('#input-type1').on('input', function () {
        editTextOnCanvas();
    });

    /**
     * Change the color of the text on the canvas
     */
    $(document).on('click', '.js-choice-editor .cc-choice-pattern_item', function (e) {
        customizePattern = $(this).find('img').attr('src');
        customizeColor = $(this).find('img').attr('alt');
        let colorName = $(this).find('img').data('name');
        $('.js-color-value').text(colorName);
        $('.js-customizePage').find('.js-choice-editor .cc-choice-pattern_item.active').removeClass('active');
        $(this).addClass('active');

        updateCanvasElem(canvasText, 'fill', customizeColor);

        e.stopPropagation();
    });

    /**
     * Select one of the 2 available hotspost
     */
    $(document).off('click', '.js-customizePage .js-positionChoice-1, .js-customizePage .js-positionChoice-2');
    $(document).on('click', '.js-customizePage .js-positionChoice-1, .js-customizePage .js-positionChoice-2', function (e) {
        isStepTwo = true;
        if ($(this).hasClass('js-positionChoice-1')) {
            selectPosition(1);
        } else if ($(this).hasClass('js-positionChoice-2')) {
            selectPosition(2);
        }
        choicePosition();
        $('.js-customizePage .js-positionChoice-1, .js-customizePage .js-positionChoice-2').hide();
        e.stopPropagation();
    });

    onZoomButtonClick();
}

function handleVariationGroupChange (data) {
    if (data.variation && data.variation.images && data.variation.images.custom_first && data.variation.images.custom_first[0]) {
        $('#img-object-front').attr('src', data.variation.images.custom_first[0].url);
        $('#img-url-front').data('url', data.variation.images.custom_first[0].url);
    }
    if (data.variation && data.variation.images && data.variation.images.custom_second && data.variation.images.custom_second[0]) {
        $('#img-object-back').attr('src', data.variation.images.custom_second[0].url);
        $('#img-url-back').data('url', data.variation.images.custom_second[0].url);
    }
    $('.js-customizePage').data('pid', data.product.id);
    waitToLoadAllImages().then(function () {
        initCanvas();
    });
}

/**
 * @function onZoomButtonClick - Add event listener on the zoom button, to zoom in/out the canvas
 */
function onZoomButtonClick () {
    $(SELECTORS.zoomButton).on('click', function (e) {
        const $this = $(this);
        const scaleValue = $this.hasClass('active') ? 1 : 1.9;

        $(SELECTORS.personalizationCanvas).css({
            transform: 'scale(' + scaleValue + ')'
        });

        $this.toggleClass('active');
        e.stopPropagation();
    });
}

/**
 * @function editTextOnCanvas - Update the text on the canvas
 */
function editTextOnCanvas () {
    customizeText = $('#input-type1').val();
    let badWordsFlag = badWords.includes(customizeText.toLowerCase().trim());
    const $inputContainer = $('#input-type1').closest('.cc-contentInput');

    if (badWordsFlag) {
        customizeText = '';
        $('.js-personalizeButtonModal').attr('disabled', true);
        $('.content-input-err').removeClass('hidden');
        $('.js-clear-input').removeClass('hidden');
        $('.js-char-counter').addClass('hidden');
        $inputContainer.addClass('flag-error');
    } else {
        $('.js-personalizeButtonModal').attr('disabled', false);
        $('.content-input-err').addClass('hidden');
        $inputContainer.removeClass('flag-error');
    }
    if (customizeText === undefined || customizeText === '') {
        $('.js-personalizeButtonModal').attr('disabled', true);
        $('.content-input-err-cyrillic').addClass('hidden');
        $('.js-clear-input').addClass('hidden');
        $('.js-char-counter').removeClass('hidden');
    } else {
        $('.js-personalizeButtonModal').attr('disabled', false);

        if (!badWordsFlag) {
            const isRegexValid = customizeText.toLowerCase().match(allowedCharactersRegex);
            if (!isRegexValid) {
                $('.js-personalizeButtonModal').attr('disabled', true);
                $('.content-input-err-cyrillic').removeClass('hidden');
                $('.js-clear-input').removeClass('hidden');
                $('.js-char-counter').addClass('hidden');
                $inputContainer.addClass('flag-error');
            } else {
                $('.js-personalizeButtonModal').attr('disabled', false);
                $('.content-input-err-cyrillic').addClass('hidden');
                $('.js-clear-input').addClass('hidden');
                $('.js-char-counter').removeClass('hidden');
                $inputContainer.removeClass('flag-error');
            }
        }
    }

    updateCanvasElem(canvasText, 'text', customizeText);

    if (customizeText !== '') {
        updateCanvasElem(canvasRect, 'stroke', '');
    } else {
        updateCanvasElem(canvasRect, 'stroke', rectColor);
    }
}

/**
 * @function updateCanvas - Re-load the canvas with a new image
 * @param {String} imageToLoad - Selector of the image tag to use for the canvas
 */
function updateCanvas (imageToLoad) {
    canvas.clear();
    initCanvas(imageToLoad);
}

/**
 * @function choicePosition - Go to step 2, function is called after clicking on the hotspot
 */
let choicePosition = function () {
    const { page, mainChoice, showOtherSide, stepOne, stepTwo, termsBottomDesktop, footer, zoomButton, personalizationChooseColor } = SELECTORS;

    if (customizePosition !== '0') {
        $(mainChoice).addClass('visible');
        $(stepOne + ', ' + termsBottomDesktop).removeClass('cc-visible');
        $(stepTwo + ', ' + footer).addClass('cc-visible');
        $(showOtherSide).removeClass('back').addClass('hide');
        $(zoomButton).removeClass('hide');
        $(personalizationChooseColor).removeClass('hide');
        $(page).removeClass(CLASSES.pageStepOne).addClass(CLASSES.pageStepTwo);
    }
};

/**
 * @function backChoicePosition - Go back to step 1, function is called after clicking on the back button
 */
let backChoicePosition = function () {
    const { page, mainChoice, hotspotOne, hotspotTwo, stepOne, stepTwo, termsBottomDesktop, footer, showOtherSide, zoomButton, personalizationChooseColor } = SELECTORS;
    isStepTwo = false;
    if (customizeSide !== '0') {
        $(showOtherSide).removeClass('hide');

        if (customizeSide === '1') {
            $(showOtherSide).addClass('back').removeClass('front');
        } else {
            $(showOtherSide).addClass('front').removeClass('back');
        }
    } else {
        $(hotspotOne).removeClass('hide');
        $(hotspotTwo).removeClass('hide');
    }
    const imageToLoad = customizeSide === '1' || customizeSide === '0' ? $(SELECTORS.imgFront) : $(SELECTORS.imgBack);

    canvas.clear();
    initText();
    initCanvas(imageToLoad);

    $(mainChoice).removeClass('visible');
    $(stepOne + ', ' + termsBottomDesktop).addClass('cc-visible');
    $(stepTwo + ', ' + footer).removeClass('cc-visible');
    $(page).addClass(CLASSES.pageStepOne).removeClass(CLASSES.pageStepTwo);
    $(hotspotOne + ', ' + hotspotTwo).show();
    $(zoomButton).removeClass('active').addClass('hide');
    $(personalizationChooseColor).addClass('hide');
};

/**
 * @function selectPosition - Select if we are using the image front or back
 * @param {Number} pos - 1: front, 2: back
 */
function selectPosition (pos) {
    const { imgFront, imgBack, pixelText, hotspotOne, hotspotTwo, showOtherSide } = SELECTORS;
    let imageToLoad = $(imgFront);
    if (pos === 1 || pos === 0) {
        top = parseInt($(pixelText).attr('top-desktop'));
        left = parseInt($(pixelText).attr('left-desktop'));
        customizePosition = pos;
        $(showOtherSide).addClass('back').removeClass('front');
        $(hotspotOne).removeClass('hide');
        if (pos !== 0) {
            $(hotspotTwo).addClass('hide');
        }
    } else {
        top = parseInt($(pixelText).attr('top-desktop-back'));
        left = parseInt($(pixelText).attr('left-desktop-back'));
        imageToLoad = $(imgBack);
        customizePosition = '2';
        $(showOtherSide).addClass('front').removeClass('back');
        $(hotspotOne).addClass('hide');
        $(hotspotTwo).removeClass('hide');
    }

    updateCanvas(imageToLoad);
}

/**
 * @function positionChoice - Add event listeners on the position buttons
 */
function positionChoice () {
    const imageFront = $('#img-url-front').attr('data-url').replace(/&/g, '&amp;');
    const imageBack = $('#img-url-back').attr('data-url').replace(/&/g, '&amp;');
    const topPercentage = (top / canvas.height) * 100;
    const leftPercentage = (left / canvas.width) * 100;
    const topBackPercentage = (topBack / canvas.height) * 100;
    const leftBackPercentage = (leftBack / canvas.width) * 100;

    if (imageBack !== '') {
        let $position1 = $('<button></button>').html($('.cordinates-spot-icon i').html()).addClass('js-pers-hotspotBtn js-positionChoice-1 cc-pers-hotspotBtn');
        let $position2 = $('<button></button>').html($('.cordinates-spot-icon i').html()).addClass('js-pers-hotspotBtn js-positionChoice-2 cc-pers-hotspotBtn');
        $position1.css({'position': 'absolute', 'top': topPercentage + '%', 'left': leftPercentage + '%', 'display': 'flex'}).appendTo('.js-section-module_result_image');
        $position2.css({'position': 'absolute', 'top': topBackPercentage + '%', 'left': leftBackPercentage + '%', 'display': 'flex'}).appendTo('.js-section-module_result_image');
        $position1.data('position', '1');
        $position2.data('position', '2');

        if (imageFront !== imageBack && !switchDisable) {
            $('.js-show-other-side').removeClass('hide').addClass('back');
            selectPosition(1);
            customizeSide = '1';
        } else {
            $('.js-show-other-side').addClass('hide');
            selectPosition(0);
            customizeSide = '0';
        }
    } else {
        let $position1 = $('<button></button>').html($('.cordinates-spot-icon i').html()).addClass('js-pers-hotspotBtn js-positionChoice-1 cc-pers-hotspotBtn');
        $position1.css({'position': 'absolute', 'top': topPercentage + '%', 'left': leftPercentage + '%', 'display': 'flex'}).appendTo('.js-section-module_result_image');
        selectPosition(0);
        customizeSide = '0';
        $position1.data('position', '1');
    }

    /**
     * Add event listener on go back button (return to step 1);
     */
    $(document).off('click', '.cc-customizePage-topbar .js-page-back');
    $(document).on('click', '.cc-customizePage-topbar .js-page-back', function (e) {
        backChoicePosition();
        e.stopPropagation();
        $('body').trigger('customize:actions', {
            action: 'back',
            pid: $('.js-customizePage').data('pid')
        });
    });

    // Cambio Fronte/Retro
    $(document).off('click', '.js-show-other-side .js-other-side-btn');
    $(document).on('click', '.js-show-other-side .js-other-side-btn', function (e) {
        if ($(this).closest('.js-show-other-side').hasClass('front')) {
            $(this).closest('.js-show-other-side').removeClass('front').addClass('back');
            selectPosition(1);
            customizeSide = '1';
        } else {
            $(this).closest('.js-show-other-side').removeClass('back').addClass('front');
            selectPosition(2);
            customizeSide = '2';
        }
    });

    $(document).on('click', '.js-choice-editor .cc-choice-item', function (e) {
        customizeFont = $(this).data('font');
        $('.form-font').val(customizeFont);

        $('.js-choice-editor .cc-choice-item.active').removeClass('active');
        $(this).addClass('active');
        $('#input-type1').css('font-family', customizeFont);

        updateCanvasElem(canvasText, 'fontFamily', customizeFont);
        e.stopPropagation();
    });

    /**
     * Creates new canvas for the export and populates data for add to cart
     */
    $(document).on('click', SELECTORS.personalizeAddToCart, function (e) {
        initForm();

        $.spinner().start();

        let canvasOptions = {
            top: top,
            left: left,
            customizeText: customizeText,
            customizeFont: customizeFont,
            customizeColor: customizeColor,
            imageToLoad: customizeSide === '1' || customizeSide === '0' ? $(SELECTORS.imgFront) : $(SELECTORS.imgBack)
        };
        let svgAllFormat = generateSvgForOTP(canvasOptions);
        let base64FullSVG = svgAllFormat.personalizationFullSVG;
        $('#base64').attr('data-fullSVG', base64FullSVG);
        let base64TextFullSVG = svgAllFormat.personalizationTextSVG;
        $('#base64').attr('data-fullTextSVG', base64TextFullSVG);
        let base64TextSmallSVG = svgAllFormat.personalizationSmallSVG;
        $('#base64').attr('data-smallSVG', base64TextSmallSVG);
        $.spinner().stop();

        let size = $('#size').attr('size-attribute').replace('/', '~');
        if (size !== '') {
            $('#' + size).attr('checked', true);
        }

        // Update modal add-to-cart
        $('body').on('product:updateAddToCart', (e, response) => {
            if (!response.product.readyToOrder || !response.product.available || response.product.comingSoon) {
                if (this.sizeModal && this.sizeModal.modal) {
                    $(this.sizeModal.modalBox).find('button.js-add-to-cart').attr('disabled', true);
                }
            } else if (this.sizeModal && this.sizeModal.modal) {
                $(this.sizeModal.modalBox).find('button.js-add-to-cart').attr('disabled', false);
            }
        });

        // Close the modal when a product is added to the cart
        $('body').on('product:afterAddToCart', (e) => {
            if (this.sizeModal && this.sizeModal.modal) {
                this.sizeModal.close();
                this.sizeModal.destroy();
            }
        });

        $('.js-personalizeButtonCheckout.js-add-to-cart').trigger('click');
    });

    // Modal Customize Terms
    $(SELECTORS.termsAndConditionsModal).on('click', function (e) {
        e.preventDefault();
        const htmlContent = $($(this).data('target')).html();
        // create and open confirmation modal
        const modal = newModalFromString(htmlContent, false);
        $('.tingle-modal:not(.jsPersonalizationToolModal)').addClass('cc-modalCustomizeTerms');
        $('.cc-modalCustomizeTerms .tingle-modal-box').addClass('cc-modalCustomizeTerms-container rightModalAttribute');
        $('.cc-modalCustomizeTerms .tingle-modal-box__content').addClass('cc-modalCustomizeTerms-container-modal');
        modal.open();
        modal.setContent(document.querySelector('.js-ModalCustomizeTerms').innerHTML);
        $(modal.modalBox)
            .find('.close')
            .on('click', function (e) {
                modal.close();
            });

        $('.js-inside-close-modal, [data-dismiss="modalBigContent"]').on('click', function (e) {
            e.preventDefault();
            modal.close();
        });
        // clicking outside of the modal or on close button has to close both terms and condition
        // and personalization modal, only with back arrow can user go back to personalization modal
        $(modal.modal).on('mousedown', function (e) {
            if ($(e.target).is(modal.modal) || $(e.target).closest('.js-close-all-modals').length) {
                modal.close();
                $('.jsPersonalizationToolModal').remove();
            }
        });
    });

    $(SELECTORS.analyticsCustomizeAction).on('click', function (e) {
        let pid = $('.js-customizePage').data('pid');
        let action = $(e.currentTarget).data('action');
        $('body').trigger('customize:actions', {action: action, pid: pid});
    });

    $(SELECTORS.pageClose).on('click', function (e) {
        $('body').trigger('customize:actions', {
            action: 'close',
            pid: $('.js-customizePage').data('pid')
        });
        $('.jsPersonalizationToolModal .tingle-modal__close').trigger('click');
        initVariables();
    });

    // Hot spot selection - define "position" attribute
    $('body').on('click', '.js-pers-hotspotBtn', e => {
        customizePosition = $(e.currentTarget).data('position');
        $('.form-position').val(customizePosition);
    });
};

module.exports = {
    runPersonalizationListener: runPersonalizationListener,
    handleVariationGroupChange: handleVariationGroupChange
};
